import DatepickerPC from "./DatepickerPC.vue.mjs";
import DatepickerH5 from "./DatepickerH5.vue.mjs";
import { isMobile } from "../../../../utils/environment.mjs";
const Datepicker = isMobile ? DatepickerH5 : DatepickerPC;
export {
  Datepicker as default
};
